<!-- //
组件-滚动表格
@auth xuyd
@date 2024-05-03
//-->
<template>
  <PropsWrapper :widgetProps="formData">
    <el-form @submit.native.prevent :model="viewProps" size="mini" :label-width="this.dvContants.labelWidth">
      <el-form-item prop="widgetName" label="标题111">
        <el-input v-model="viewProps.title" style="width: 100%" maxlength="20"></el-input>
      </el-form-item>
    </el-form>
  </PropsWrapper>
</template>

<script>
export default {
  name: 'WidgetScrollTableForm',
  components: {},
  data() {
    return {
      formData: this.widgetProps,
    }
  },
  props: {
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    viewProps() {
      return this.widgetProps.viewProps;
    }
  },
  watch: {
    widgetProps: {
      handler: function (val) {
        console.log(`---------watch ${this.$options._componentTag} widgetProps-------->`);
        this.formData = val;
      },
      immediate: false
    }
  },
}
</script>

<style lang="less" scoped>

</style>
